<template>
  <v-app>
    <v-content class="not-found--bg">
      <v-container fill-height>
        <v-layout
          column
          justify-center
          fill-height
        >
          <v-card
            color="transparent"
            flat
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm5
              >
                <div class="not-found--404 text-center text-sm-right">
                  404
                </div>
              </v-flex>
              <v-flex
                xs12
                sm7
              >
                <v-card-title class="white--text text-center text-sm-left">
                  <div style="width:100%;">
                    <div class="display-3">
                      You are lost
                    </div>
                    <div class="headline">
                      This page doesn't exist
                    </div>
                    <v-btn
                      to="/"
                      outlined
                      color="white"
                    >
                      Take me Home
                    </v-btn>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style>
.not-found--bg {
  background: linear-gradient(to bottom right, #009688, #90A4AE);
}

.not-found--404 {
  color: white;
  font-size: 8em;
  padding: 20px;
}
</style>
